export default __webpack_public_path__ + "static/media/Lost Voices Soundscape.59e41e76.mp3";